import { Component, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { TopNavComponent } from './topnav';
import { SidebarComponent } from './sidebar';
import { MapComponent } from '../components/map/map.component';
import { ModalService } from '../services/modal.service';
import { PendingRequestsService } from '../utils/pending-requests.service';

@Component({
  standalone: true,
  selector: 'dashboard-app',
  templateUrl: 'dashboard.component.html',
  encapsulation: ViewEncapsulation.None,
  imports: [CommonModule, RouterOutlet, TopNavComponent, SidebarComponent, MapComponent],
})
export class DashboardComponent {
  isLoading = false;

  constructor(
    public modalService: ModalService,
    private pendingRequests: PendingRequestsService,
  ) {
    let showLoadingHandler: any = 0;
    this.pendingRequests.pending$.subscribe((pendings) => {
      if (pendings > 0 && !showLoadingHandler) {
        showLoadingHandler = window.setTimeout(() => {
          this.isLoading = true;
        }, 1000);
      } else if (pendings === 0) {
        clearTimeout(showLoadingHandler);
        showLoadingHandler = null;
        this.isLoading = false;
      }
    });
  }
}
